import React, { FC, useCallback, useState } from 'react';
import { StyledControlPage } from '@pages/Main/Access/Products/ProductPage.style';
import Product from '../../Common/Product/Product';
import Spec from '@pages/Main/Common/Spec/Spec';
import Purchase from '@pages/Main/Common/Purchase/Purchase';
import BannerScroll from '@pages/Main/Common/Banner/BannerScroll';
import seoProduct from '@src/lang/ko/seoProduct';
import seoProductEng from '@src/lang/en/seoProduct';
import seoProductJP from '@src/lang/jp/seoProduct';
import seoProductCN from '@src/lang/cn/seoProduct';
import seoProductVI from '@src/lang/vi/seoProduct';
import i18n from '@pages/i18n';
import SEO from '@pages/SEO';
import { useLocation } from 'react-router-dom';
import { StyledGridContainer } from '@components/Grid/Grid.style';
import ModalDone from '@pages/Enterprise/Download/ModalDone/ModalDone';
import { Spacing } from '@pages/CommonStyle/common.style';
import NewsLetter from '@pages/Main/Common/NewsLetter/NewsLetter';

interface ProductProps {
  category: string;
}

const OsServer: FC<ProductProps> = ({ category }) => {
  const initialProduct = 'osServer';

  const [productName, setProduct] = useState<string>(initialProduct);
  const [imgGroupIndex, setImgGroupIndex] = useState<number>(0);

  let seoPath;
  const location = useLocation();

  if (location.pathname.includes('/en/')) {
    seoPath = seoProductEng;
  } else if (location.pathname.includes('/jp/')) {
    seoPath = seoProductJP;
  } else if (location.pathname.includes('/cn/')) {
    seoPath = seoProductCN;
  } else if (location.pathname.includes('/vi/')) {
    seoPath = seoProductVI;
  } else {
    seoPath = seoProduct;
  }

  const currentLang = i18n.language;
  const helmetTitle = seoPath.osServer.title;
  const ogKey = seoPath.osServer.key;
  const ogDesc = seoPath.osServer.desc;
  const ogImg = seoPath.osServer.img;
  const ogUrl = seoPath.osServer.url;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: helmetTitle,
    description: ogDesc,
    url: ogUrl,
    keywords: ogKey,
    image: ogImg,
    brand: {
      '@type': 'Brand',
      name: 'ORBRO',
    },

    review: {
      '@type': 'Review',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: 4.9,
        bestRating: 5,
      },
      author: {
        '@type': 'Person',
        name: 'ORBRO',
      },
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: 4.9,
      reviewCount: 99,
    },
    offers: {
      '@type': 'AggregateOffer',
      offerCount: 5,
      lowPrice: 2000000,
      highPrice: 15000000,
      priceCurrency: 'KRW',
    },
  };

  const [isSuccess, setSuccess] = useState<boolean>(false);
  const onSuccess = useCallback(() => {
    setSuccess(!isSuccess);
  }, [isSuccess]);

  return (
    <>
      <SEO lang={currentLang} helmetTitle={helmetTitle} ogKey={ogKey} ogDesc={ogDesc} ogImg={ogImg} ogUrl={ogUrl} jsonLd={jsonLd} />
      <BannerScroll product={'os'} selectedGroup={0} />
      <StyledControlPage>
        <Purchase category={category} productName={productName} setProduct={setProduct} setImgGroupIndex={setImgGroupIndex}></Purchase>
      </StyledControlPage>
      <Product productName={productName} imgGroupIndex={imgGroupIndex}></Product>
      {/* <Spec productName={productName}></Spec> */}

      <StyledGridContainer>
        <Spacing pixel="64" />
        {isSuccess && <ModalDone onClickToggleModal={onSuccess}></ModalDone>}
        <NewsLetter onSuccess={onSuccess} />
        <Spacing pixel="64" />
      </StyledGridContainer>
    </>
  );
};

export default OsServer;
